export default __webpack_public_path__ + "google_classroom_x48_yellow_stroke_icon.png";